import React, { useContext } from 'react';
import { AppContext } from 'App.context';
import styles from './Modals.styles';
import Colors from 'constants/Colors';

export default function PreviewChainAppearance({ logoImage = null, customStyles = {} }) {
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const hotel = getSelectedHotel();
  const {
    textAndBorderColor = Colors.darkText,
    backgroundColor = '#FF0000',
    buttonColor = '#FFFF00',
  } = customStyles;

  return (
    <div
      style={{
        ...styles.chainWrapper,
        backgroundColor,
      }}
    >
      <div
        style={{
          ...styles.chainLanguageSelector,
          color: textAndBorderColor,
        }}
      >
        Español <span style={{ fontWeight: 'bold' }}>▼</span>
      </div>

      <div style={styles.chainLogoContainer}>
        <div style={{ ...styles.chainLogoBox}}>
          {logoImage ? (
            <img src={logoImage} alt="logo" style={styles.chainLogoImage} />
          ) : (
            <span style={{ ...styles.chainLogoPlaceholder, color: textAndBorderColor }}>+</span>
          )}
        </div>
      </div>

      <h2 style={{ ...styles.chainTitle, color: textAndBorderColor }}>
        {translate('common.selectYourHotel')}
      </h2>

      <div style={styles.chainHotelBox}>
        <label style={{ ...styles.chainHotelLabel, color: textAndBorderColor }}>* Hotel</label>
        <select
          style={{
            ...styles.chainHotelSelect,
            border: 'none',
            pointerEvents: 'none',
            userSelect: 'none',
            backgroundColor: 'transparent',
            color: Colors.darkText,
          }}
        >
          <option>{hotel?.name}</option>
        </select>
      </div>

      <button
        style={{ ...styles.chainContinueButton, backgroundColor: buttonColor, color: Colors.white }}
      >
        {translate('common.continue') || 'Continuar'}
      </button>
    </div>
  );
}
